import StacksApp from '@zondax/ledger-stacks';
import { NETWORK } from 'constants/base';

import { requestPublicKeyForStxAccount } from './stacks-ledger-utils';

async function delay(ms: number) {
  return new Promise((resolve) => setTimeout(resolve, ms));
}

interface PullStacksKeysFromLedgerDeviceArgs {
  onRequestKey?(keyIndex: number): void;
}

export function pullStacksKeysFromLedgerDevice(
  stacksApp: StacksApp,
  customPath: string,
  netwok: NETWORK
) {
  return async ({ onRequestKey }: PullStacksKeysFromLedgerDeviceArgs): Promise<any> => {
    const publicKeys = [];
    const amountOfKeysToExtractFromDevice = 10;
    for (let index = 0; index < amountOfKeysToExtractFromDevice; index++) {
      if (onRequestKey) onRequestKey(index);
      const stxPublicKeyResp = await requestPublicKeyForStxAccount(
        stacksApp,
        customPath,
        netwok
      )(index);

      if (!stxPublicKeyResp.publicKey) return { status: 'failure', ...stxPublicKeyResp };

      publicKeys.push({
        stxPublicKey: stxPublicKeyResp.publicKey.toString('hex'),
      });
    }
    await delay(100);

    return { status: 'success', publicKeys };
  };
}
